<script>
import 'bulma/css/bulma.css'
import modalWindow from '@/components/ModalWindow'
import {changeRoleOfMember, removeMemberFromTeam} from '@/api/FirebaseTeamWrapper.js'
require('@/css/style.css')

export default {
  components: {modalWindow},
  props: ['memberData', 'myUserId', 'myTeamRole', 'teamId', 'memberLength', 'ownerLength'],
  data () {
    return {
      selectedRole: this.memberData.role,
      updatedMsg: '',
      deletedMsg: '',
      confirmMsg: '',
      enableDeleteUser: false
    }
  },
  async created () {
  },
  watch: {
    selectedRole: async function () {
      this.updatedMsg = ''
      this.deletedMsg = ''
      await this.updateRole()
    },
    teamId: function () {
      this.updatedMsg = ''
      this.deletedMsg = ''
    },
    memberData: {
      handler: function (val) {
        this.selectedRole = this.memberData.role
      },
      deep: true
    },
    updatedMsg: function () {
      if (this.updatedMsg.length > 0) {
        setTimeout(() => { this.updatedMsg = '' },
          1000)
      }
    },
    deleteMsg: function () {
      if (this.deleteMsg.length > 0) {
        setTimeout(() => { this.deleteMsg = '' },
          1500)
      }
    }
  },
  methods: {
    async updateRole () {
      this.updatedMsg = ''
      // role変更がなければreturn
      if (this.selectedRole === this.memberData.role) { return }
      console.log(this.ownerLength)

      if (this.ownerLength <= 1 && this.selectedRole === 'member') {
        this.updatedMsg = 'No owner'
        return
      }

      try {
        await changeRoleOfMember(this.teamId, this.memberData.userId, this.selectedRole)
        this.updatedMsg = '成功'
        this.$emit('updateRole')
      } catch (err) {
        console.error(err)
        this.updatedMsg = '失敗'
      }
    },
    deleteMember () {
      this.deletedMsg = ''
      const teamLength = this.memberLength - 1
      if (teamLength < 1 || (this.ownerLength <= 1 && this.selectedRole === 'owner')) {
        this.deletedMsg = 'No owner'
        return
      }
      this.confirmMsg = this.memberData.name + 'を本当に削除しますか？'
      this.enableDeleteUser = true
    },
    cancelDelete () {
      this.enableDeleteUser = false
      this.confirmMsg = ''
    },
    async doDelete () {
      try {
        await removeMemberFromTeam(this.teamId, this.memberData.userId)
        this.$emit('deleteMember')
        this.confirmMsg = ''
        this.enableDeleteUser = false
      } catch (err) {
        this.confirmMsg = ''
        this.deletedMsg = '失敗'
        this.enableDeleteUser = false
      }
    }
  }
}
</script>
<style scoped>
.card-content {
  padding: 0.5rem;
}
.column .delete{
  background-color: #ff3860;
}
select {
  border: 0;
  cursor: pointer;
  cursor: hand;
}
.member-name {
  margin: 0.3rem;
}
.delete-btn {
  margin-top: 0.8rem;
  margin-right: 1.6rem;
  cursor: pointer;
  cursor: hand;
}

.toast {
  margin-top: 0.5rem;
  background-color: #f14668;
  padding: 0.2rem 0.8rem;
  border-radius: 0.5rem;
  position: absolute;
  width: max-content;
  z-index: 5;
}

</style>
<template>
  <div class="teamcard">
    <div class="card">
      <div class="card-content">
        <div class="columns is-multiline is-mobile is-marginless">
          <div class="column is-half">
            <p class="member-name is-size-7 has-text-weight-bold has-text-left">@{{memberData.name}}</p>
          </div>
          <div class="column is-one-quarter has-text-right" v-if="myTeamRole === 'owner'">
            <select v-model="selectedRole">
              <option disabled value="">Roleの選択</option>
              <option>member</option>
              <option>owner</option>
            </select>
            <div class="toast has-text-white is-size-8" v-if="updatedMsg">{{updatedMsg}}</div>
          </div>
          <div class="column is-paddingless has-text-right"  v-if="myTeamRole === 'owner'">
            <div class="delete-btn">
              <span class="icon" @click="deleteMember()"><i class="fa-solid fa-xmark"></i></span>
            </div>
            <div class="toast has-text-white is-size-8" v-if="deletedMsg">{{deletedMsg}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="Delete-modal-window">
      <modalWindow @close="cancelDelete()" v-if="enableDeleteUser">
        <template slot="header">
          <div class="buttons is-right">
            <button class="delete" @click="cancelDelete()"></button>
          </div>
        </template>
        <p>{{confirmMsg}}</p>
        <template slot="footer">
          <div class="buttons is-centered">
            <button class="button" @click="cancelDelete()">キャンセル</button>
            &nbsp;
            &nbsp;
            &nbsp;
            <button class="button is-link" @click="doDelete()">削除</button>
          </div>
        </template>
      </modalWindow>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/editteam/TeamCard.vue